import { render } from "./ViewFilters.vue?vue&type=template&id=5255be32"
import script from "./ViewFilters.vue?vue&type=script&lang=js"
export * from "./ViewFilters.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__